import React from "react";
import Modal from "react-responsive-modal";

import WComponent from "../../common/WComponent";
import Button from "../../common/button/Button";
import UserAssigner from "../../common/user_assigner/UserAssigner";
import DateSelector from "../../common/date_selector/DateSelector";

import "../../common/modal/modal.css";

export const BULK_ACTIONS = {
	reassign: "reassign",
	due: "due"
};

/**
 * Collects the input for a bulk action on the selected tasks.
 *
 * Props:
 *   show    : boolean
 *   action  : "reassign" | "due"
 *   count   : number of selected tasks
 *   onClose : ({ confirmed, payload }) => void, payload is { assignedUsers } or { deadline }
 */
class BulkActionModal extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			assignedUsers: [],
			deadline: new Date()
		};
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.show && this.props.show) {
			this.setState({ assignedUsers: [], deadline: new Date() });
		}
	}

	onAssignedUsersChanged = ({ selectedUsers }) => {
		this.setState({ assignedUsers: selectedUsers.slice() });
	};

	onDeadlineChange = date => {
		this.setState({ deadline: date });
	};

	onCancel = () => {
		this.props.onClose({ confirmed: false });
	};

	onApply = () => {
		const { action, onClose } = this.props;
		const { assignedUsers, deadline } = this.state;

		if (action === BULK_ACTIONS.reassign) {
			onClose({ confirmed: true, payload: { assignedUsers } });
			return;
		}

		onClose({ confirmed: true, payload: { deadline } });
	};

	render() {
		const { show, action, count } = this.props;
		const { assignedUsers, deadline } = this.state;

		const isReassign = action === BULK_ACTIONS.reassign;
		const noun = count === 1 ? "task" : "tasks";

		return (
			<Modal open={!!show} onClose={this.onCancel} center classNames={{ modal: "bulk-action-modal" }}>
				<div className="modal-title">{isReassign ? `Reassign ${count} ${noun}` : `Change due date for ${count} ${noun}`}</div>

				<div className="bulk-action-modal__body">
					{isReassign && (
						<>
							<p className="bulk-action-modal__hint">The people below replace the current assignees on every selected task.</p>
							<UserAssigner onChange={this.onAssignedUsersChanged} users={assignedUsers} showNotificationToggle />
						</>
					)}

					{!isReassign && (
						<DateSelector
							containerClass="bulk-action-modal__date"
							title="New deadline"
							selectedDate={deadline}
							onDateSelect={this.onDeadlineChange}
							dateFormat={"MMMM d, yyyy h:mm aa"}
							showTimeSelect={true}
						/>
					)}
				</div>

				<div className="modal-footer">
					<Button view="secondary" text="Cancel" onClick={this.onCancel} className="ft-task-bulk-cancel" />
					<Button text="Apply" onClick={this.onApply} disabled={isReassign && assignedUsers.length === 0} className="ft-task-bulk-apply" />
				</div>
			</Modal>
		);
	}
}

export default BulkActionModal;
